import { render, staticRenderFns } from "./DocumentPOSPrintTotal.vue?vue&type=template&id=6f8b999c&scoped=true"
import script from "./DocumentPOSPrintTotal.vue?vue&type=script&lang=js"
export * from "./DocumentPOSPrintTotal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPOSPrintTotal.vue?vue&type=style&index=0&id=6f8b999c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b999c",
  null
  
)

export default component.exports